import { createContext } from "react";

import { NON_DOCK_PANEL_KEY } from "~/helpers/panelKey";

const DockPanelContext = createContext<boolean | undefined>(undefined);

export const DockPanelVisibleContext = createContext<boolean | undefined>(undefined);

export const DockPanelKeyContext = createContext<string>(NON_DOCK_PANEL_KEY);

export default DockPanelContext;
